<template>
    <div class="mb-6 w-full">
        <p class="mb-4 flex gap-2 text-base font-bold leading-6 text-black">{{props.title}}
            <slot name="custom-icon" class="shrink-0"></slot>
        </p>
        <slot>
            <p class="text-sm leading-5 text-black" v-html="innerHtml"></p>
        </slot>
    </div>
</template>

<script setup lang="ts">
import { withDefaults, computed } from 'vue';
import { replace } from 'lodash'
import { useI18n } from 'vue-i18n';
import { splitText } from '@eureka/utils/text';
const { t: $t } = useI18n();

const props = withDefaults(defineProps<{
    title: string;
    content?: string;
    noDataText?: string;
}>(), {
    title: '',
    content: '',
    noDataText: '',
});

const innerHtml = computed(() => {
    const reg = /<b\s+class="similar-content"\s*>/g;
    const text = replace(props.content, reg, `<b class="similar-content" data-tip="${$t('similarWithYour')}">`);
    if (!text) {
        return `<p class="text-sm leading-5 text-black">${props.noDataText}</p>`
    }
    return splitText(text).map(p => `<p class="mb-3 last:mb-0">${p}</p>`).join('')
});

</script>
<style lang="scss">
.similar-content {
    display: inline !important;
    @apply text-yellow-500 relative font-normal th-tooltip th-tooltip-dark;
    .similar-label {
        @apply whitespace-nowrap th-badge th-badge-sm th-badge-warning absolute -top-2 -left-4;
    }
}
</style>
